import React from 'react';
import './flex-separator.scss';

const FlexSeparator = () => <div styleName="flex-separator" />;

export default FlexSeparator;
